export default __webpack_public_path__ + "static/media/notificationImage.5f55e802.jpg";